<div class="d-flex flex-column recommendation-section">
    @if(isFetchingRecipients){
    <div class="appointments-loader-overlay d-flex flex-column">
        <mat-spinner diameter="36"></mat-spinner>
        <p class="fw-medium mt-2 p-clr ">Fetching recipients, please wait..</p>
    </div>
    }
    <div class="record-content flex-grow-1 overflow-auto pb-2 flex-1 m-h-0">
        <div class="px-2">
            @if(isLoading) {
            <div class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <p class="text-muted fw-medium">
                        Generating recommended ACC Eligibilities...
                    </p>

                </div>
            </div>
            } @else{
            @if(accElgibility.length === 0 && accServiceCodes.length === 0){

            <div class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <img src="{{ cvaUI_url + '/assets/icons/acc-eligibility.svg' }}" alt="ACC Eligibilities"
                        aria-hidden="true" class="icon-sm ico-task">

                    <p class="text-muted">
                        You don't have any ACC Eligibilities yet.
                    </p>
                </div>
            </div>
            } @else {
            <mat-accordion multi displayMode="flat" class="acc-sections d-block w-100">
                <!-- Section A: ACC classification code -->
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="fw-medium">
                            ACC classification codes
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    @if(accElgibility.length === 0){
                    <p class="text-muted small mb-0">No ACC classification codes recommended.</p>
                    }
                    <div class="list-group list-group-flush">
                        <div *ngFor="let record of accElgibility; let i = index; trackBy: trackByIndex">
                            <div class="border rounded p-2 mb-2 shadow-sm bg-white">
                                <div class="d-flex align-items-start gap-2">
                                    @if(!record.isSaved){
                                    <input type="checkbox" (keydown.space)="toggleCheckbox(i)"
                                        (click)="toggleCheckbox(i)"
                                        class="cursor-pointer form-check-input mt-1 custom-check-input" name="checkmark"
                                        [checked]="record.checked" />
                                    }
                                    <div class="flex-grow-1 " [ngClass]="{'ml-1-25':record.isSaved}">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span class="badge bg-custom-gray text-black border fw-medium">
                                                {{ record.Read_code }}
                                            </span>
                                            <div class="d-flex justify-content-end gap-2">

                                                @if(record.isSaved){
                                                <span class="badge bg-success fs-xx-small fw-medium">
                                                    <i class="bi bi-check-circle-fill"></i> ACC Added
                                                </span>
                                                }
                                            </div>
                                        </div>
                                        <div class="small mt-2">
                                            <div class="text-black lh-sm text-break fw-medium">
                                                {{ record.FSN_description }}
                                            </div>

                                            <p class="mb-0 mt-1 text-black lh-sm text-break">
                                                @if (expandedRecords.has(i)) {
                                                {{ record.justification }}
                                                } @else {
                                                {{ record.justification | slice:0:100 }}{{ record.justification.length >
                                                100 ?
                                                '...' : '' }}
                                                }

                                                @if (record.justification.length > 100 && !expandedRecords.has(i)) {
                                                <span tabindex="0"
                                                    class="fw-medium pointer text-grey text-decoration-none show-more"
                                                    (click)="toggleExpanded(i)">show
                                                    more</span>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <!-- Section B: ACC service code -->
                <mat-expansion-panel [expanded]="true" class="mt-3">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="fw-medium">
                            ACC service codes
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    @if(accServiceCodes.length === 0){
                    <p class="text-muted small mb-0">No ACC service codes recommended.</p>
                    }
                    <div class="list-group list-group-flush">
                        <div *ngFor="let record of accServiceCodes; let i = index; trackBy: trackByIndex">
                            <div class="border rounded p-2 mb-2 shadow-sm bg-white">
                                <div class="d-flex align-items-start gap-2">
                                    @if(!record.isSaved){
                                    <input type="checkbox" (keydown.space)="toggleServiceCheckbox(i)"
                                        (click)="toggleServiceCheckbox(i)"
                                        class="cursor-pointer form-check-input mt-1 custom-check-input"
                                        name="checkmark-service" [checked]="record.checked" />
                                    }
                                    <div class="flex-grow-1" [ngClass]="{'ml-1-25':record.isSaved}">
                                        <div class="d-flex align-items-center justify-content-between flex-wrap gap-1">
                                            <div class="d-flex align-items-center flex-wrap gap-1">
                                                <span class="badge bg-custom-gray text-black border fw-medium">
                                                    {{ record.code }}
                                                </span>
                                                @if(false){
                                                <span
                                                    class="badge bg-light text-muted border fw-normal fs-xx-small text-capitalize">
                                                    {{ record.category.split('_').join(' ') }}
                                                </span>
                                                }
                                            </div>
                                            @if(record.isSaved){
                                            <span class="badge bg-success fs-xx-small fw-medium">
                                                <i class="bi bi-check-circle-fill"></i> ACC Added
                                            </span>
                                            }
                                        </div>
                                        <div class="small mt-2">
                                            <div class="text-black lh-sm text-break fw-medium">
                                                {{ record.description }}
                                            </div>

                                            @if(record.price && record.price !== 'PLACEHOLDER'){
                                            <div class="text-muted lh-sm mt-1">Price: {{ record.price }}</div>
                                            }

                                            @if(record.report_code){
                                            <div class="text-muted lh-sm mt-1">Report code: {{ record.report_code }}
                                            </div>
                                            }
                                            @if(record.regulation_item){
                                            <div class="text-muted lh-sm mt-1">Regulation item: {{
                                                record.regulation_item }}</div>
                                            }
                                            @if(record.justification){
                                            <p class="mb-0 mt-1 text-black lh-sm text-break">
                                                @if (expandedServiceRecords.has(i)) {
                                                {{ record.justification }}
                                                } @else {
                                                {{ record.justification | slice:0:100 }}{{ record.justification.length >
                                                100 ?
                                                '...' : '' }}
                                                }

                                                @if (record.justification.length > 100 &&
                                                !expandedServiceRecords.has(i)) {
                                                <span tabindex="0"
                                                    class="fw-medium pointer text-grey text-decoration-none show-more"
                                                    (click)="toggleServiceExpanded(i)">show
                                                    more</span>
                                                }
                                            </p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            }
            }
        </div>

    </div>
    @if(accElgibility.length || accServiceCodes.length){
    <div class="d-flex justify-content-end align-items-center flex-wrap gap-2 px-2 pt-3 pb-1">
        <button type="button" class="btn btn-dark btn-sm" [disabled]="isSubmitDisabled" (click)="postChecked()">
            Post
        </button>
    </div>
    }
    <ng-template #doctorDialog>
        <div class="recipient-dialog">
            <div class="recipient-dialog-header">
                <h2 class="recipient-title">
                    Select Recipient
                </h2>
                <p class="recipient-subtitle">
                    Select a facility member to receive this ACC eligibility code.
                </p>
            </div>
            <div class="recipient-dialog-body">
                <div class="recipient-field">
                    <label for="recipient" class="recipient-label">
                        Recipient <span class="required">*</span>
                    </label>
                    <select id="recipient" class="recipient-select" [(ngModel)]="selectedRecipient"
                        #recipientModel="ngModel" required>
                        <option value="" disabled>
                            Select recipient
                        </option>
                        <option *ngFor="let recipient of recipients" [value]="recipient.referenceId">
                            {{ recipient.firstName }} {{ recipient.lastName }}
                        </option>
                    </select>
                    <div class="required-message" *ngIf="recipientModel.touched && recipientModel.invalid">
                        Please select a recipient.
                    </div>
                </div>
                <div class="recipient-preference">
                    <label class="align-items-center recipient-checkbox">
                        <input type="checkbox" [(ngModel)]="saveRecipientAsDefault" />

                        <span class="checkbox-label fs-7 fw-medium ">
                            Save this recipient as my default
                        </span>

                        <mat-icon
                            matTooltip="This recipient will be preselected the next time you post an ACC eligibility code."
                            matTooltipPosition="right" class="cursor-pointer mat-info-icon">
                            info
                        </mat-icon>
                    </label>
                </div>
            </div>

            <div class="recipient-dialog-actions">
                <button type="button" class="recipient-btn secondary-action" (click)="closeDialog()">
                    Cancel
                </button>
                <button type="button" class="recipient-btn primary-action" (click)="selectedRecipient && submit()">
                    Submit
                </button>
            </div>
        </div>
    </ng-template>